import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Button } from 'react-bootstrap';
import { FaShieldAlt, FaHome, FaArrowLeft } from 'react-icons/fa';
import './ErrorPages.css';

const AccessDenied = () => {
  const navigate = useNavigate();

  return (
    <div className="error-page-wrapper">
      <Container className="error-container">
        <div className="error-content">
          {/* Icon */}
          <div className="error-icon-wrapper">
            <FaShieldAlt className="error-icon access-denied-icon" />
          </div>

          {/* Error Code */}
          <h1 className="error-code">403</h1>

          {/* Error Message */}
          <h2 className="error-title">Access Denied</h2>
          <p className="error-description">
            You don't have permission to access this page.
            <br />
            Administrator privileges are required to access Setup and configuration features.
          </p>

          {/* Action Buttons */}
          <div className="error-actions">
            <Button
              variant="primary"
              size="lg"
              onClick={() => navigate('/')}
              className="error-btn error-btn-primary"
            >
              <FaHome className="me-2" />
              Go to Home
            </Button>
            <Button
              variant="outline-secondary"
              size="lg"
              onClick={() => navigate(-1)}
              className="error-btn error-btn-secondary"
            >
              <FaArrowLeft className="me-2" />
              Go Back
            </Button>
          </div>

          {/* Help Text */}
          <div className="error-help">
            <p className="text-muted">
              If you believe you should have access to this area, please contact your system administrator.
            </p>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default AccessDenied;
